import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import UserManagement from './UserManagement';
import FeriasManagement from './FeriasManagement';
import PresencaSheets from './PresencaSheets';
import BaixasMedicas from './BaixasMedicas';
import HorasExtra from './HorasExtra';
import Folhasdepresençav2 from './Folhasdepresençav2';


const FerramentasAdministrativas = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <DashboardLayout>
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>Ferramentas Administrativas</Typography>
                
                <Tabs value={selectedTab} onChange={handleChange} sx={{ marginBottom: 3 }}>
                    <Tab label="Gestão de Users" />
                    <Tab label="Gestão de Férias" />
                    <Tab label="Folhas de Presença" />
                    <Tab label="Baixas Médicas" />
                    <Tab label="Horas Extra" />
                    <Tab label="Folhasdepresençav2" />
                </Tabs>

                {/* Conteúdo de cada aba */}
                <Box sx={{ p: 2 }}>
                    {selectedTab === 0 && <UserManagement />}
                    {selectedTab === 1 && <FeriasManagement />}
                    {selectedTab === 2 && <PresencaSheets />}
                    {selectedTab === 3 && <BaixasMedicas />}
                    {selectedTab === 4 && <HorasExtra />}
                    {selectedTab === 5 && <Folhasdepresençav2 />}
                </Box>
            </Box>
        </DashboardLayout>
    );
};

export default FerramentasAdministrativas;
